/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExamDto,
  ExamParticipantDto,
  StarterHistoryItemDto,
  ExamScheduleEntryDto,
  ExamDetailsDto,
} from '../models/index';
import {
    ExamDtoFromJSON,
    ExamDtoToJSON,
    ExamParticipantDtoFromJSON,
    StarterHistoryItemDtoFromJSON,
    ExamScheduleEntryDtoFromJSON,
    ExamDetailsDtoFromJSON,
} from '../models/index';

export interface ApiExamHistoryGetRequest {
    showId?: number | null;
    riderRegisterId?: string | null;
    horseRegisterId?: string | null;
}

export interface ApiExamByShowShowIdBookerBookerIdGetRequest {
    showId: number;
    bookerId: string;
}

export interface ApiExamByShowShowIdGetRequest {
    showId: number;
}

export interface ApiExamExamIdDetailsGetRequest {
    examId: number;
}

export interface ApiExamScheduleGetRequest {
    showId: number;
}

/**
 * 
 */
export class ExamApi extends runtime.BaseAPI {

    /**
     */
    async apiExamByShowShowIdBookerBookerIdGetRaw(requestParameters: ApiExamByShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExamDto>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling apiExamByShowShowIdBookerBookerIdGet().'
            );
        }

        if (requestParameters['bookerId'] == null) {
            throw new runtime.RequiredError(
                'bookerId',
                'Required parameter "bookerId" was null or undefined when calling apiExamByShowShowIdBookerBookerIdGet().'
            );
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }

        const response = await this.request({
            path: `/api/Exam/ByShow/${encodeURIComponent(String(requestParameters['showId']))}/booker/${encodeURIComponent(String(requestParameters['bookerId']))}`,
            method: 'GET',
            headers: headerParameters,
            query: {},
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExamDtoFromJSON));
    }

    /**
     */
    async apiExamByShowShowIdBookerBookerIdGet(requestParameters: ApiExamByShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExamDto>> {
        const response = await this.apiExamByShowShowIdBookerBookerIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiExamByShowShowIdGetRaw(requestParameters: ApiExamByShowShowIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExamDto>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError('showId', 'Required parameter "showId" was null or undefined when calling apiExamByShowShowIdGet().');
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }

        const response = await this.request({
            path: `/api/Exam/ByShow/${encodeURIComponent(String(requestParameters['showId']))}`,
            method: 'GET',
            headers: headerParameters,
            query: {},
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExamDtoFromJSON));
    }

    /**
     */
    async apiExamByShowShowIdGet(requestParameters: ApiExamByShowShowIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExamDto>> {
        const response = await this.apiExamByShowShowIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Teilnehmerliste einer Prüfung (exam_details)
     */
    async apiExamExamIdDetailsGetRaw(requestParameters: ApiExamExamIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExamDetailsDto>> {
        if (requestParameters['examId'] == null) {
            throw new runtime.RequiredError('examId', 'Required parameter "examId" was null or undefined when calling apiExamExamIdDetailsGet().');
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }

        const response = await this.request({
            path: `/api/Exam/${encodeURIComponent(String(requestParameters['examId']))}/details`,
            method: 'GET',
            headers: headerParameters,
            query: {},
        }, initOverrides);

        return new runtime.JSONApiResponse(response, ExamDetailsDtoFromJSON);
    }

    /**
     * Prüfungshistorie nach Show, Reiter oder Pferd
     */
    async apiExamHistoryGetRaw(requestParameters: ApiExamHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StarterHistoryItemDto>>> {
        const queryParameters: any = {};
        if (requestParameters['showId'] != null) queryParameters['showId'] = requestParameters['showId'];
        if (requestParameters['riderRegisterId'] != null) queryParameters['riderRegisterId'] = requestParameters['riderRegisterId'];
        if (requestParameters['horseRegisterId'] != null) queryParameters['horseRegisterId'] = requestParameters['horseRegisterId'];

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }

        const response = await this.request({
            path: `/api/Exam/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StarterHistoryItemDtoFromJSON));
    }

    /**
     * Prüfungshistorie nach Show, Reiter oder Pferd
     */
    async apiExamHistoryGet(requestParameters: ApiExamHistoryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StarterHistoryItemDto>> {
        const response = await this.apiExamHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Teilnehmerliste einer Prüfung (exam_details)
     */
    async apiExamExamIdDetailsGet(requestParameters: ApiExamExamIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExamDetailsDto> {
        const response = await this.apiExamExamIdDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /** Prüfungsplan eines Turniers */
    async apiExamScheduleGet(requestParameters: ApiExamScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExamScheduleEntryDto>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError('showId', 'Required parameter "showId" was null or undefined when calling apiExamScheduleGet().');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY");
        }
        const response = await this.request({
            path: `/api/Exam/schedule`,
            method: 'GET',
            headers: headerParameters,
            query: { showId: requestParameters['showId'] },
        }, initOverrides);
        return await new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExamScheduleEntryDtoFromJSON)).value();
    }

}
